<template>
<!-- 跳转小程序 盒子 -->
<div @click='gotoApplet'>
  <!-- 微信公众号下的h5 -->
  <div v-if="isWxFrontVue"  :class="className">
    <span>{{ btnText }}</span>
    <wx-open-launch-weapp
      style="position:absolute; z-index: 2; top:0; left:0; width: 100%; height: 44px;"
      :username="username"
      :path="path"
    >
      <!-- 在开发工具调试获取不到script -->
      <script  type="text/wxtag-template">
        <div style="position:absolute; top:0;  left:0;  width:100%; height:100%; opacity:0; z-index: 2;"></div>
      </script>
    </wx-open-launch-weapp>
  </div>
  <!-- 小程序/APP环境 -->
  <div v-else :class="className">
    <span>{{ btnText }}</span>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  props: {
    isWxFrontVue: {
      type: Boolean, // 是否微信H5
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  filters: {},
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    gotoApplet () {
      if (this.isWxFrontVue) {
        return
      }
      this.$emit('gotoApplet')
    }
  } /* methods末 */
}
</script>

<style lang="scss">
</style>
